import { type TransportAirlineApiContext } from "../../../../../common/utils/transport/airlineTransportContext";

export type SwissTravelPassResolvedPaths =
  | { kind: "invalid_airline" }
  | {
      kind: "ok";
      mainPath: string;
      bookingsPath: string;
    };

export function resolveSwissTravelPassApiPaths(
  transportContext: TransportAirlineApiContext
): SwissTravelPassResolvedPaths {
  if (transportContext.mode === "airline_missing_iata") {
    return { kind: "invalid_airline" };
  }
  if (transportContext.mode === "airline") {
    const base = `v1/airports/${encodeURIComponent(transportContext.iataCode)}/transports/swiss-travel-pass`;
    return {
      kind: "ok",
      mainPath: base,
      bookingsPath: `v1/airports/${encodeURIComponent(transportContext.iataCode)}/bookings`
    };
  }
  return {
    kind: "ok",
    mainPath: "transport/swiss-travel-pass",
    bookingsPath: "transport/swiss-travel-pass/bookings"
  };
}
